export class RecruitPreferenceOption {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.description = json && json.description || null;
        this.parentID = json && json.parent_preference_id || null;
        this.preferenceTypeID = json && json.preference_type_id || null;
        this.selected = false;
    }

    id: number;
    description: string;
    parentID: number | null;
    preferenceTypeID: number;
    selected: boolean;
}